import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, Collapse, IconButton, TableCell, TableRow, Typography } from '@mui/material';
import { KeyboardArrowUp as KeyboardArrowUpIcon, KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material'
import moment from 'moment';

export default function WorklogListRow(props) {
  const { row } = props;
  const maxLength = 50;
  const [open, setOpen] = React.useState(false);

  const convertDate = (date)=>{
    return moment(date, "YYYY-MM-DD hh:mm:ss").format('DD/MM/YYYY hh:mm:ss')
  }

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.worklogComment.substring(0, 50).trim() + (row.worklogComment.length > maxLength ? '...':'')}
        </TableCell>
        <TableCell align="left">{row.updtdBy}</TableCell>
        <TableCell align="left">{convertDate(row.updatedDateStr)}</TableCell>

      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="subtitle2" component="div">
                Comment:&nbsp;
                <Typography variant="body2" component="label">
                  {row.worklogComment}
                </Typography>
              </Typography>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

WorklogListRow.propTypes = {
  row: PropTypes.shape({
    // id: PropTypes.number.isRequired,
    worklogComment: PropTypes.string.isRequired,
    createdDateStr: PropTypes.any.isRequired,
    crtdBy: PropTypes.any.isRequired,
  }).isRequired,
};